import { alpha, Box, keyframes, Typography } from "@mui/material";

const ripple = keyframes`
	0% { transform: scale(1); opacity: 1; }
	100% { transform: scale(1); opacity: 0.5; }
`;

type Props = {
	isInDelay: boolean;
};

export const StatusIndicator = ({ isInDelay }: Props) => {
	return (
		<Box
			sx={{
				px: 1.5,
				py: 0.5,
				borderRadius: 1,
				display: "flex",
				alignItems: "center",
				gap: 1,
				backgroundColor: (theme) =>
					isInDelay
						? alpha(theme.palette.error.main, 0.1)
						: alpha(theme.palette.success.main, 0.1),
				border: (theme) =>
					`1px solid ${isInDelay ? theme.palette.error.main : theme.palette.success.main}`,
			}}
		>
			<Box
				sx={{
					width: 5,
					height: 5,
					borderRadius: "50%",
					backgroundColor: (theme) =>
						isInDelay ? theme.palette.error.main : theme.palette.success.main,
					animation: `${ripple} 1s ease-out infinite`,
				}}
			/>
			<Typography
				sx={{
					fontSize: "0.7rem",
					fontWeight: 700,
					color: (theme) =>
						isInDelay ? theme.palette.error.main : theme.palette.success.main,
					lineHeight: 1,
				}}
			>
				{isInDelay ? "IN DELAY" : "RUNNING"}
			</Typography>
		</Box>
	);
};
